import React from "react";
import { Box, Typography } from "@mui/material";
import "./LianLianBrandingPanel.scss";

export default function LianLianBrandingPanel({ productName = "", coBrandingText = "", logoSrc = "" }) {
    return (
        <Box className="lianlian-branding-panel">
            <Box className="lianlian-branding-panel__center">
                <Typography
                    variant="h2"
                    component="div"
                    className="lianlian-branding-panel__title"
                >
                    {productName}
                </Typography>
                <Typography
                    component="div"
                    className="lianlian-branding-panel__cobranding-text"
                >
                    {coBrandingText}
                </Typography>
            </Box>
            <img className="lianlian-branding-panel__logo" src={logoSrc} alt="Logo" />

        </Box>
    );
}
